const detalhesCobertura = [{
    index:       5,
    title:       "Cobertura de Agregado / Implementos",
    subtitle:    "Detalhes",
    image:       require("@/assets/images/delivery.svg"),
    text:        "Essa cobertura é exclusiva para veículos de carga, criada para você que tem seu caminhão rodando por todo Brasil e busca por uma cobertura mais completa para não deixar nada de fora, seja um 4° eixo, equipamento de guincho, uma carroceria ou até mesmo uma carreta, podera contratar mais essa cobertura para deixar seu bruto bem protegido.",
    indenizacao: false,
}, {
    index:       7,
    title:       "Sem perfil de condutor",
    subtitle:    "Detalhes",
    image:       require("@/assets/images/chauffeur.svg"),
    text:        "Nossa proteção é totalmente desburocratizada e não trabalhamos com perfil de condutor, é isso mesmo, você não precisa ficar informando sempre quem é o condutor, desde que o mesmo esteja habilitado para conduzir o veículo.",
    indenizacao: false,
}, {
    index:       8,
    title:       "Cobertura nacional 24h",
    subtitle:    "Detalhes",
    image:       require("@/assets/images/brazil.svg"),
    text:        "Aqui na Protruck além de um atendimento humanizado, nós te damos um cobertura completa em todo territorio nacional sem restrição de horários ou rota, porque sabemos que para o trabalho não existe hora marcada nem rota certa.",
    indenizacao: false,
}
];


export { detalhesCobertura };
